module.exports = "<headerMenu></headerMenu>\r\n<app-map [positions]=\"mapMarker\"></app-map>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/mywallet/store/storemap/storemap.component.html
// module id = ./src/app/mywallet/store/storemap/storemap.component.html
// module chunks = main